export const stripQueryParameters = (path: string) => path.replace(/:[^/]+/, '')

// Site numbers come from the backend spaced all sorts of ways, so regroup UK
// numbers the standard way (01225 310 000, 0117 321 2000, 020 8998 1000).
// Anything that isn't a UK number is left as it is.
export const formatPhoneNumber = (phone: string): string => {
  let digits = phone.replace(/\D/g, '')
  if (digits.startsWith('44') && digits.length === 12) {
    digits = `0${digits.slice(2)}`
  }

  if (!/^0\d{10}$/.test(digits)) {
    return phone.trim()
  }

  if (digits.startsWith('02')) {
    return `${digits.slice(0, 3)} ${digits.slice(3, 7)} ${digits.slice(7)}`
  }

  // 0117, 0161 etc. and 03/08/09 numbers
  if (/^01(1\d|\d1)|^0[389]/.test(digits)) {
    return `${digits.slice(0, 4)} ${digits.slice(4, 7)} ${digits.slice(7)}`
  }

  if (digits.startsWith('07')) {
    return `${digits.slice(0, 5)} ${digits.slice(5)}`
  }

  return `${digits.slice(0, 5)} ${digits.slice(5, 8)} ${digits.slice(8)}`
}
